import styled from 'styled-components';

export const Background = styled.div`
    position: fixed;
    top: -10000px;
    left: -10000px;
    width: 0;
    height: 0;
    background-color: rgba(0,0,0, 0.8);

    &.opened {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;

export const Window = styled.div`
    position: fixed;
    top: -10000px;
    left: -10000px;
    width: 800px;
    height: 540px;
    transform: Translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    background-color: #333;

    &.opened {
        top: 50%;
        left: 50%;
    }
`;

export const WindowTitle = styled.div`
    width: 100%;
    height: 35px;
    min-height: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    background-color: #444;
    padding-left: 10px;
    text-transform: uppercase;
    color: #fff;
    font-size: 14px;
`;

export const WindowContent = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const ColumnGeneral = styled.div`
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    padding: 20px 10px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const ColumnContent = styled.div`
    flex: 3;
    height: 100%;
    box-sizing: border-box;
    padding: 20px 10px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const Row = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${(p) => p.justify ?? 'stretch'};
    margin-bottom: ${(p) => p.marginBottom ?? '20px'};;
`;

export const Column = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: ${p => p.align ?? 'center'};
    justify-content: flex-start;
`;

export const Input = styled.input.attrs(p => ({
    type: "text"
}))`
    color: #fff;
    border: 1px solid #7d7d7d;
    background-color: #111;
    height: 25px;
    padding: 0 0 0 5px;
    width: 100%;
    min-width: 100px;
    margin-bottom: 10px;
`;

export const Timer = styled.input.attrs(p => ({
    type: "text"
}))`
    color: #fff;
    border: 1px solid #7d7d7d;
    background-color: #111;
    height: 25px;
    padding: 0 0 0 5px;
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    box-sizing: border-box;
    flex: 1;
    margin-bottom: 10px;
`;

export const Select = styled.select.attrs(p => ({
    type: "text"
}))`
    color: #fff;
    border: 1px solid #7d7d7d;
    background-color: #111;
    height: 25px;
    padding: 0 0 0 5px;
    width: 100%;
    min-width: 100px;
    margin-bottom: 10px;
`;

export const Label = styled.div`
    color: #999;
    font-size: 14px;
    margin-bottom: 5px;
    width: 100%;

    &.small {
        width: auto;
        min-width: auto;
        font-size: 10px;
    }
`;

export const Subtitle = styled.div`
    color: #999;
    font-size: 12px;
    width: 100%;
    line-height: 16px;
    margin: 0 0 -20px 0;
`;

export const Divisor = styled.div`
    color: #777;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    margin: 15px 0 20px 0;

    &:before,
    &:after {
        content: '';
        height: 1px;
        background-color: #777;
        flex: 1;
    }

    &:before { margin-right: 10px }
    &:after { margin-left: 10px }
`;

export const ButtonsBar = styled.div`
    width: 100%;
    height: 70px;
    min-height: 70px;
    padding: 20px;
    box-sizing: border-box;
    border-top: 1px solid #999;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;

export const Button = styled.div`
    padding: 0 10px;
    height: 30px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: color .3s ease 0s;
    margin-right: 10px;
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    transition: all .4s ease 0s;

    &:last-child {
        margin-right: 0;
    }

    &:hover {
        background-color: ${props => props.color};
        color: #fff;
    }
`;
